import { createBrowserHistory } from 'history'
const history = typeof window !== 'undefined' ? createBrowserHistory() : null

import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'

import KatalogRazdeli from './../block/KatalogRazdeli'
import Breadcrumbs from './../block/Breadcrumbs'
import RecommendedSection from './../block/RecommendedSection'
import PromotionsSection from './../block/PromotionsSection'
import FAQSection from './../block/FAQSection'

import ProductCardSm from './../block/ProductCardSm';
import MemoizedHTML from './../block/MemoizedHTML'

import axios from 'axios'

import ClientOnlySlider from '../block/ClientOnlySlider'

import queryString from 'query-string'

import { Container, Card, Row, Col, Form, Pagination as BPagination, Spinner, DropdownButton, Dropdown, Offcanvas } from 'react-bootstrap'

import 'rc-slider/assets/index.css'
import styles from './../style/Katalog.module.scss'

if (typeof window !== 'undefined') {
  const history = createBrowserHistory()
} else {
  const history = false
}

export default class Katalog extends Component {

  constructor(props) {
    super(props)
    
    this.myRef = createRef()
    
    const { count, page, products, vsego, zapros } = props.ajax_data.start
    
    var catalogmenuKey = 0,
    catalogmenuKeyChild = 0
    
    if('parents' in props.ajax_data) {
      props.catalogmenu.map(( elm ) => {
        if( props.ajax_data.parents.includes( elm.id ) ) {
          catalogmenuKey = elm.id
          elm.child.map(( celm ) => {
            if( props.ajax_data.parents.includes( celm.id ) ) {
              catalogmenuKeyChild = elm.id
            }
          })
        }
      })
    }
    
    const option_vals = {}
    const option_search = {}
    props.ajax_data.options.map(( option ) => {
      option_vals[ option?.key ] = ``
      option_search[ `${option?.key}_search` ] = ``
    })
    
    this.state = {
      filter_titles: {
        dir: true,
        price: true,
        vendor: true,
        favorite: true,
        made_in: true,
        serteficate: true
      },
      catalogmenuKey: catalogmenuKey,
      catalogmenuKeyChild: catalogmenuKeyChild,
      page: page,
      min_price: 0,
      max_price: props.ajax_data.max_price,
      vendor: props.ajax_data?.get?.vendor || ``,
      made_in: props.ajax_data?.get?.made_in || ``,
      favorite_f: props.ajax_data?.get?.favorite_f || ``,
      serteficate: props.ajax_data?.get?.serteficate || ``,
      count: count,
      vsego: vsego,
      zapros: zapros,
      products: products,
      sortVal: `updated_asc`,
      sortName: `новинки`,
      show: false,
      recomended: [],
      loading: false,
      favorite_page: props?.favorite_page || false,
      option_vals: option_vals,
      vendor_search: '', // Добавляем состояние для поиска производителей
      ...option_search
    }
  }

  handleFilterSearch = (e, optionKey) => {
    this.setState({
      [`${optionKey}_search`]: e.target.value
    })
  }

  changeFTitles = ( key ) => {
    const { filter_titles } = this.state
    filter_titles[ key ] = !filter_titles[ key ]
    
    // Сбрасываем поиск при закрытии секции
    if (!filter_titles[key]) {
      let newState = { filter_titles: filter_titles }
      
      if (key === 'vendor') {
        newState.vendor_search = ''
      }
      // Для option фильтров (из предыдущего ответа)
      else if (this.props.ajax_data.options?.some(opt => opt?.key === key)) {
        newState[`${key}_search`] = ''
      }
      
      this.setState(newState)
    } else {
      this.setState({
        filter_titles: filter_titles
      })
    }
  }

  changeSort = ( val, name ) => {
    this.setState({
      sortVal: val,
      sortName: name,
      products: null
    }, () => {
      this.loadProducts()
    })
  }

  priceFormat(price, delimiter, fraction) {
    if(price == 0 || price == '' || price == null) return 0
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 0
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  loadProducts = () => {
    const { min_price, max_price, vendor, made_in, favorite_f, serteficate, page, sortVal, option_vals } = this.state

    const baseURL = window.location.protocol + "//" + window.location.hostname,
    pathname = window.location.pathname,
    main = this

    this.setState({
      loading: true
    }, () => {
      axios.post(`${baseURL}${pathname}`, {
        'content_type': 'application/json',
        'action': 'load_products_razdel',
        'min': min_price,
        'max': max_price,
        'vendor': vendor,
        'made_in': made_in,
        'favorite': favorite_f,
        'serteficate': serteficate,
        'page': page,
        'sort': sortVal,
        ...option_vals
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Request-Source': 'Node.js'
        }
      }).then( ( response ) => {
        main.setState({
          products: response.data.products,
          count: response.data.count,
          page: response.data.page,
          vsego: response.data.vsego,
          zapros: response.data.zapros,
          loading: false
        })
      })
    })
  }

  changeCatalogmenuKeyChild = ( key ) => {
    const { catalogmenuKeyChild } = this.state
    this.setState({
      catalogmenuKeyChild: catalogmenuKeyChild == key ? null : key
    })
  }

  changeCatalogmenuKey = ( key ) => {
    const { catalogmenuKey } = this.state
    this.setState({
      catalogmenuKey: catalogmenuKey == key ? null : key
    })
  }

  submitFilter = () => {
    if(this.timer) clearTimeout(this.timer)
    const main = this
    this.timer = setTimeout(function() {
      main.setState({
        page: 1,
        products: null,
        count: 0,
        vsego: 0
      }, () => {
        main.changePath()
      })
    }, 500)
  }

  rangeUpdate(arr) {
    this.setState( {
        min_price: arr[0],
        max_price: arr[1]
    }, () => {
      this.submitFilter()
    })
  }

  change_favorite( val ) {
    this.setState( {
      favorite_f: val
    }, () => {
      this.submitFilter()
    })
  }
  change_vendor( val ) {
    this.setState( {
      vendor: val
    }, () => {
      this.submitFilter()
    })
  }
  change_made_in( val ) {
    this.setState( {
      made_in: val
    }, () => {
      this.submitFilter()
    })
  }
  change_serteficate( val ) {
    this.setState( {
      serteficate: val
    }, () => {
      this.submitFilter()
    })
  }

  change_option( val, key ) {
    const { option_vals } = this.state
    option_vals[key] = val
    this.setState( {
      option_vals: option_vals
    }, () => {
      this.submitFilter()
    })
  }

  inCart = ( id ) => {
    const { cart } = this.props
    var fined = false
    cart.map(( celm ) => {
      if( celm.product == id ) {
        fined = true
      }
    })
    return fined
  }

  changePath = () => {
    const { ajax_data } = this.props,
    { page, min_price, max_price, vendor, made_in, favorite_f, serteficate, option_vals } = this.state,
    baseURL = window.location.protocol + "//" + window.location.hostname,
    pathname = window.location.pathname

    var search = {}
    if( page > 1 ) search.page = page
    if( Number( min_price ) > 0 ) search.min = Number( min_price )
    if( Number( max_price ) < Number( ajax_data.max_price ) ) search.max = Number( max_price )
    if( Number( vendor ) > 0 ) search.vendor = Number( vendor )
    if( made_in != '' ) search.made_in = made_in
    if( Number( favorite_f ) > 0 ) search.favorite = Number( favorite_f )
    if( Number( serteficate ) > 0 ) search.serteficate = Number( serteficate )
    if (option_vals) {
      Object.keys(option_vals).forEach(key => {
        const value = option_vals[key];
        if (value !== undefined && value !== null && value !== '') {
          search[key] = value;
        }
      });
    }
    var search_string = queryString.stringify( search, {arrayFormat: 'separator', arrayFormatSeparator: '|'} )

    if(history) history.push( `${baseURL}${pathname}` + ( search_string != '' ? `?` + search_string : `` ) )
  }

  changePage = ( e, num ) => {
    const { page } = this.state

    e.preventDefault()

    if(num == page) return

    this.setState({
      page: num
    }, () => {
      this.changePath()
      window.scrollTo(0, 0)
    })
  }

  handleShow() {
    this.setState({
      show: true
    })
  }

  handleClose() {
    this.setState({
      show: false
    })
  }

  getSearchParams = () => {
    const { ajax_data } = this.props

    var search_arr = queryString.parse( window.location.search, {
      types: {
        page: 'number',
        min: 'number',
        max: 'number',
        vendor: 'number',
        made_in: 'string',
        favorite: 'number',
        serteficate: 'number'
      }
    } )
    this.setState({
      page: search_arr.page ? search_arr.page : 1,
      min_price: search_arr.min ? search_arr.min : 0,
      max_price: search_arr.max ? search_arr.max : ajax_data.max_price,
      vendor: search_arr.vendor ? search_arr.vendor : 0,
      made_in: search_arr.made_in ? search_arr.made_in : ``,
      favorite_f: search_arr.favorite ? search_arr.favorite : 0,
      serteficate: search_arr.serteficate ? search_arr.serteficate : 0
    }, () => {
      this.loadProducts()
    })
  }

  setTab = ( num ) => {
    this.setState({
      tab: num
    })
  }

  componentDidMount() {
    if( history ) {
      history.listen(() => {
        this.getSearchParams()
      })
    }
  }

  render() {

    const { ajax_data, favorite, cart, changeFavorite, catalogmenu, page_data, addTocart, user_profile_type, catalog } = this.props,
    { filter_titles, catalogmenuKey, catalogmenuKeyChild, min_price, max_price, vendor, made_in, favorite_f, serteficate, count, vsego, products, page, sortName, loading, favorite_page, show, option_vals } = this.state

    const filtr = (
      <div className={styles.razdel_leftfilter}>
        <div onClick={() => this.changeFTitles( 'dir' )} className={filter_titles.dir ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
          <div>Категория</div>
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L11 1" stroke="black"/>
          </svg>
        </div>
        <div className={filter_titles.dir ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
          <div className={styles.razdel_leftfilter_content_accordion}>
            {catalogmenu.map((elm, k) => {
              if(elm.child != null) return (
                <div key={k} className={styles.razdel_leftfilter_content_accordion_el}>
                  <div onClick={() => this.changeCatalogmenuKey(elm.id  )} className={catalogmenuKey == elm.id ? styles.razdel_leftfilter_content_accordion_el_header_open : styles.razdel_leftfilter_content_accordion_el_header}>
                    <a className='d-none d-lg-inline' href={elm.url}>{elm.name.replace(/<[^>]+>/g, ' ')}</a>
                    {catalogmenuKey == elm.id ?
                      <a className='d-lg-none' href={elm.url}>{elm.name.replace(/<[^>]+>/g, ' ')}</a>
                    :
                      <div className='d-lg-none'>{elm.name.replace(/<[^>]+>/g, ' ')}</div>
                    }
                    {elm?.child.length > 0 &&
                      <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6 6L11 1" stroke="black"/>
                      </svg>
                    }
                  </div>
                  <div className={catalogmenuKey == elm.id ? styles.razdel_leftfilter_content_accordion_el_body_open : styles.razdel_leftfilter_content_accordion_el_body}>
                    {elm.child.map((celm, j) => {
                      if('parents' in ajax_data) return (
                        <>
                          <div key={j}>
                            {ajax_data.parents.includes( celm.id ) ?
                              <>
                                <a href={celm.url} className={styles.razdel_leftfilter_content_accordion_el_1_active}>
                                  {/*
                                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                                    <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                                  </svg>
                                  */}
                                  <div>{celm.name.replace(/<[^>]+>/g, ' ')}</div>
                                </a>
                                {celm.child.map((ccelm, i) => {
                                  return (
                                    <a key={i} className={ajax_data.parents.includes( ccelm.id ) ? styles.razdel_leftfilter_content_accordion_el_2_active : styles.razdel_leftfilter_content_accordion_el_2} href={ccelm.url}>{ccelm.name.replace(/<[^>]+>/g, ' ')}</a>
                                  )
                                })}
                              </>
                            :
                              <>
                                {celm.child.length == 0 ?
                                  <a href={celm.url} className={styles.razdel_leftfilter_content_accordion_el_1}>
                                    {/*
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                    </svg>
                                    */}
                                    <div>{celm.name.replace(/<[^>]+>/g, ' ')}</div>
                                  </a>
                                :
                                  <>
                                    {catalogmenuKeyChild == celm.id ?
                                      <>
                                        <a href={celm.url} className={styles.razdel_leftfilter_content_accordion_el_1}>
                                          {/*
                                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                          </svg>
                                          */}
                                          <div>{celm.name.replace(/<[^>]+>/g, ' ')}</div>
                                        </a>
                                        {celm.child.map((ccelm, i) => {
                                          return (
                                            <a key={i} className={ajax_data.parents.includes( ccelm.id ) ? styles.razdel_leftfilter_content_accordion_el_2_active : styles.razdel_leftfilter_content_accordion_el_2} href={ccelm.url}>{ccelm.name.replace(/<[^>]+>/g, ' ')}</a>
                                          )
                                        })}
                                      </>
                                    :
                                      <a style={{ cursor: `pointer` }} onClick={() => this.changeCatalogmenuKeyChild( celm.id )} className={styles.razdel_leftfilter_content_accordion_el_1}>
                                        {/*
                                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                        </svg>
                                        */}
                                        <div>{celm.name.replace(/<[^>]+>/g, ' ')}</div>
                                      </a>
                                    }
                                  </>
                                }
                              </>
                            }
                          </div>
                        </>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        {'max_price' in ajax_data &&
          <>
            {ajax_data.max_price > 0 &&
              <>
                <div onClick={() => this.changeFTitles( 'price' )} className={filter_titles.price ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
                  <div>Цена, ₽</div>
                  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="black"/>
                  </svg>
                </div>
                <div className={filter_titles.price ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
                  <ClientOnlySlider
                    range
                    min={0}
                    max={Number( ajax_data.max_price )}
                    value={[min_price, max_price]}
                    onChange={(e) => this.rangeUpdate(e)}
                  />
                  <Row>
                    <Col xs="6">
                      <Form.Group>
                        <Form.Label className={styles.razdel_leftfilter_pricetitle}>От</Form.Label>
                        <Form.Control className={styles.razdel_leftfilter_priceinput} type="text" onChange={(e) => this.rangeUpdate([ Number( e.target.value ), max_price ])} value={min_price} />
                      </Form.Group>
                    </Col>
                    <Col xs="6">
                      <Form.Group>
                        <Form.Label className={styles.razdel_leftfilter_pricetitle}>До</Form.Label>
                        <Form.Control className={styles.razdel_leftfilter_priceinput} type="text" onChange={(e) => this.rangeUpdate([ min_price, Number( e.target.value ) ])} value={max_price} />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </>
            }
          </>
        }
        <div onClick={() => this.changeFTitles( 'favorite' )} className={filter_titles.favorite ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
          <div>Участвует в акции</div>
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L11 1" stroke="black"/>
          </svg>
        </div>
        <div className={filter_titles.favorite ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
          <Row>
            <Col xs="12">
              <div onClick={() => this.change_favorite( 1 )} className={styles.razdel_leftfilter_content_color}>
                <div className='d-flex align-items-center'>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {1 == favorite_f ?
                      <>
                        <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                        <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                      </>
                    :
                      <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                    }
                  </svg>
                  <div className={1 == favorite_f ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>Да</div>
                </div>
              </div>
            </Col>
            <Col xs="12">
              <div onClick={() => this.change_favorite( `` )} className={styles.razdel_leftfilter_content_color}>
                <div className='d-flex align-items-center'>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {`` == favorite_f ?
                      <>
                        <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                        <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                      </>
                    :
                      <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                    }
                  </svg>
                  <div className={`` == favorite_f ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>Показывать все</div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        {'vendors' in ajax_data &&
          <>
            {ajax_data.vendors.length > 0 &&
              <>
                <div onClick={() => this.changeFTitles( 'vendor' )} className={filter_titles.vendor ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
                  <div>Производитель</div>
                  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="black"/>
                  </svg>
                </div>
                <div className={filter_titles.vendor ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
                  {/* Добавляем поисковое поле если производителей больше 10 */}
                  {ajax_data.vendors.length > 10 && (
                    <div className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Поиск производителя..."
                        className={styles.filter_search_input}
                        onChange={(e) => this.setState({ vendor_search: e.target.value })}
                        value={this.state.vendor_search || ''}
                      />
                      {this.state.vendor_search && (
                        <small className="text-muted mt-1 d-block">
                          Найдено: {
                            ajax_data.vendors.filter(vendor => 
                              vendor.name.toLowerCase().includes(this.state.vendor_search.toLowerCase())
                            ).length
                          }
                        </small>
                      )}
                    </div>
                  )}
                  
                  <Row>
                    {ajax_data.vendors
                      .filter(vendor => {
                        // Фильтруем по поисковому запросу
                        const searchTerm = this.state.vendor_search || '';
                        return !searchTerm || 
                          vendor.name.toLowerCase().includes(searchTerm.toLowerCase());
                      })
                      .map(( elm, k ) => {
                        return (
                          <Col key={k} xs="12">
                            <div onClick={() => this.change_vendor( elm.id )} className={styles.razdel_leftfilter_content_color}>
                              <div className='d-flex align-items-center'>
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  {elm.id == vendor ?
                                    <>
                                      <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                                      <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                                    </>
                                  :
                                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                  }
                                </svg>
                                <div className={elm.id == vendor ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>{elm.name}</div>
                              </div>
                            </div>
                          </Col>
                        )
                    })}
                    {/* Кнопка "Показывать все" - всегда отображается */}
                    <Col xs="12">
                      <div onClick={() => this.change_vendor( `` )} className={styles.razdel_leftfilter_content_color}>
                        <div className='d-flex align-items-center'>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            {`` == vendor ?
                              <>
                                <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                                <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                              </>
                            :
                              <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                            }
                          </svg>
                          <div className={`` == vendor ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>Показывать все</div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </>
            }
          </>
        }
        {'made_in' in ajax_data &&
          <>
            {ajax_data.made_in.length > 0 &&
              <>
                <div onClick={() => this.changeFTitles( 'made_in' )} className={filter_titles.made_in ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
                  <div>Страна</div>
                  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="black"/>
                  </svg>
                </div>
                <div className={filter_titles.made_in ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
                  <Row>
                    {ajax_data.made_in.map(( elm, k ) => {
                      if(elm != '') return (
                        <Col key={k} xs="12">
                          <div onClick={() => this.change_made_in( elm )} className={styles.razdel_leftfilter_content_color}>
                            <div className='d-flex align-items-center'>
                              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                {elm == made_in ?
                                  <>
                                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                                    <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                                  </>
                                :
                                  <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                }
                              </svg>
                              <div className={elm == made_in ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>{elm}</div>
                            </div>
                          </div>
                        </Col>
                      )
                    })}
                    <Col xs="12">
                      <div onClick={() => this.change_made_in( `` )} className={styles.razdel_leftfilter_content_color}>
                        <div className='d-flex align-items-center'>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            {`` == made_in ?
                              <>
                                <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                                <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                              </>
                            :
                              <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                            }
                          </svg>
                          <div className={`` == made_in ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>Показывать все</div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </>
            }
          </>
        }
        <div onClick={() => this.changeFTitles( 'serteficate' )} className={filter_titles.serteficate ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
          <div>Покупка по сертификату</div>
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L11 1" stroke="black"/>
          </svg>
        </div>
        <div className={filter_titles.serteficate ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
          <Row>
            <Col xs="12">
              <div onClick={() => this.change_serteficate( 1 )} className={styles.razdel_leftfilter_content_color}>
                <div className='d-flex align-items-center'>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {1 == serteficate ?
                      <>
                        <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                        <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                      </>
                    :
                      <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                    }
                  </svg>
                  <div className={1 == serteficate ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>Да</div>
                </div>
              </div>
            </Col>
            <Col xs="12">
              <div onClick={() => this.change_serteficate( `` )} className={styles.razdel_leftfilter_content_color}>
                <div className='d-flex align-items-center'>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {`` == serteficate ?
                      <>
                        <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                        <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                      </>
                    :
                      <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                    }
                  </svg>
                  <div className={`` == serteficate ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>Показывать все</div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        {ajax_data.options.map(( option ) => (
          <>
            <div onClick={() => this.changeFTitles( option?.key )} className={filter_titles[option?.key] ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
              <div>{option?.title}</div>
              <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="black"/>
              </svg>
            </div>
            <div className={filter_titles[option?.key] ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
              {/* Добавляем поисковое поле если значений больше 10 */}
              {option?.vals.length > 10 && (
                <div className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder={`Поиск ${option?.title.toLowerCase()}...`}
                    className={styles.filter_search_input}
                    onChange={(e) => this.handleFilterSearch(e, option?.key)}
                  />
                </div>
              )}
              
              <Row>
                {option?.vals.map(( elm, k ) => {
                  // Получаем отфильтрованные значения для этого option
                  const searchTerm = this.state[`${option?.key}_search`] || '';
                  const shouldShow = !searchTerm || 
                    elm.toLowerCase().includes(searchTerm.toLowerCase());
                  
                  if(!shouldShow) return null;
                  
                  if(elm != '') return (
                    <Col key={k} xs="12">
                      <div onClick={() => this.change_option( elm, option?.key )} className={styles.razdel_leftfilter_content_color}>
                        <div className='d-flex align-items-center'>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            {elm == option_vals[option?.key] ?
                              <>
                                <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                                <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                              </>
                            :
                              <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                            }
                          </svg>
                          <div className={elm == option_vals[option?.key] ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>{elm}</div>
                        </div>
                      </div>
                    </Col>
                  )
                })}
                
                {/* Кнопка "Показывать все" - всегда отображается */}
                <Col xs="12">
                  <div onClick={() => this.change_option( ``, option?.key )} className={styles.razdel_leftfilter_content_color}>
                    <div className='d-flex align-items-center'>
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {`` == option_vals[option?.key] ?
                          <>
                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                            <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6" stroke="#1E9FF6" />
                          </>
                        :
                          <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                        }
                      </svg>
                      <div className={`` == option_vals[option?.key] ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>Показывать все</div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        ))}
      </div>
    )

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />

        <div>
          <Container className={styles.razdel_contener}>
            <h1>{ajax_data.pagetitle}</h1>

            <KatalogRazdeli
              items={catalog}
            />

            <div className={styles.razdel_filtri + ` d-md-none`}>
              <div>Фильтры:</div>
              <div className={styles.razdel_filtri_el}>{this.priceFormat(min_price)} ₽ - {this.priceFormat(max_price)} ₽</div>
              {favorite_f == 1 &&
                <div className={styles.razdel_filtri_el}>Участвует в акции</div>
              }
              {vendor != `` &&
                <div className={styles.razdel_filtri_el}>Производитель: {vendor}</div>
              }
              {made_in != `` &&
                <div className={styles.razdel_filtri_el}>Страна: {made_in}</div>
              }
              {serteficate == 1 &&
                <div className={styles.razdel_filtri_el}>Покупка по сертификату</div>
              }
            </div>

            <div className='d-flex align-items-center justify-content-between'>
              {products != null &&
                <div className={styles.razdel_rcontent_topstr}>Найдено {vsego} товаров</div>
              }
              <div className='d-lg-none'>
                <svg onClick={() => this.handleShow()} width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 5H26" stroke="black" strokeWidth="0.75" strokeLinecap="round"/>
                  <path d="M26 16.25H1" stroke="black" strokeWidth="0.75" strokeLinecap="round"/>
                  <circle cx="9.125" cy="4.375" r="4" fill="white" stroke="black" strokeWidth="0.75"/>
                  <circle cx="4.375" cy="4.375" r="4" transform="matrix(-1 0 0 1 22.25 11.25)" fill="white" stroke="black" strokeWidth="0.75"/>
                </svg>
              </div>
              <DropdownButton
                variant="light"
                align="end"
                className={styles.razdel_rcontent_sort}
                title={`Сортировка: ` + sortName}
              >
                <Dropdown.Item className={styles.razdel_rcontent_sort_elm} onClick={() => this.changeSort( 'price_asc', `сначала дешевле` )}>Сначала дешевле</Dropdown.Item>
                <Dropdown.Item className={styles.razdel_rcontent_sort_elm} onClick={() => this.changeSort( 'price_desc', `сначала дороже` )}>Сначала дороже</Dropdown.Item>
                <Dropdown.Item className={styles.razdel_rcontent_sort_elm} onClick={() => this.changeSort( 'updated_asc', `новинки` )}>По новизне</Dropdown.Item>
              </DropdownButton>
            </div>

            <div className={styles.razdel_contener_fp}>
              <div className='d-none d-lg-block'>{filtr}</div>
              <div className={styles.razdel_rcontent}>
                {products != null ?
                  <>
                    {products.length > 0 ?
                      <>
                        <div className={loading ? styles.recomendedng_catalog_loading : styles.recomendedng_catalog}>
                          {products.map(( elm, i ) => {
                            return (
                              <ProductCardSm
                                id={elm.id}
                                title={elm.title}
                                image={elm.image}
                                article={elm.article}
                                manufacturer={elm?.manufacturer || ''}
                                price={elm.price}
                                old_price={elm?.old_price}
                                inStock={elm.inStock}
                                recomended={elm.recomended}
                                changeFavorite={changeFavorite}
                                favorite={favorite}
                                cart={cart}
                                addTocart={addTocart}
                                user_profile_type={user_profile_type}
                                link={elm.url}
                                fullWidth={true}
                                certificate={elm?.certificate}
                              />
                            )
                          })}
                          {count > 1 &&
                            <>
                              <div className='d-flex w-100 justify-content-center'>
                                <BPagination className={styles.recomendedng_pagenav}>
                                  {[...Array( count )].map(( num, key ) => {
                                    num = key + 1
                                    return (
                                      <BPagination.Item href={`${ajax_data.url_ng}?page=${num}`} onClick={(e) => this.changePage( e, num )} key={key} active={num == page ? true : false}>{num}</BPagination.Item>
                                    )
                                  })}
                                  {page < count &&
                                    <BPagination.Next href={`${ajax_data.url_ng}?page=${page + 1}`} onClick={(e) => this.changePage( e, page + 1 )}>Вперед →</BPagination.Next>
                                  }
                                </BPagination>
                              </div>
                            </>
                          }
                        </div>
                      </>
                    :
                      <div style={{ height: `300px` }} className='d-flex w-100 align-items-center justify-content-center text-center'>
                        <div>По вашему запросу не найдено товаров, попробуйте изменить параметры фильтра</div>
                      </div>
                    }
                  </>
                :
                  <div style={{ height: `800px` }} className='d-flex w-100 align-items-center justify-content-center'>
                    <Spinner animation="border" variant="dark" />
                  </div>
                }
              </div>
            </div>
            {ajax_data.btext != null &&
              <Card className={styles.razdel_spectext + ' mt-4'}>
                <Card.Body>
                  <div dangerouslySetInnerHTML={{__html: ajax_data.btext}} />
                </Card.Body>
              </Card>
            }
          </Container>
        </div>

        <section>
          <Container className={styles.razdel_contener}>
            <MemoizedHTML html={ajax_data?.content || ''} />
          </Container>
        </section>

        <RecommendedSection
          page_data={page_data}
          products={ajax_data?.popular || []}
          changeFavorite={changeFavorite}
          favorite={favorite}
          cart={cart}
          addTocart={addTocart}
          user_profile_type={user_profile_type}
        />
        {!favorite_page &&
          <PromotionsSection
            page_data={page_data}
            products={ajax_data?.favorite || []}
            changeFavorite={changeFavorite}
            favorite={favorite}
            cart={cart}
            addTocart={addTocart}
            user_profile_type={user_profile_type}
          />
        }
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
        <Offcanvas show={show} onHide={() => this.handleClose()}>
          {/* Шапка Offcanvas */}
          <Offcanvas.Header className={styles.offc_header}>
            <div className={styles.offc_headerContent}>
              <div className={styles.offc_headerTitle}>Каталог</div>
              <button onClick={() => this.handleClose()} className={styles.offc_closeButton}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L15 15" stroke="black"/>
                  <path d="M15 1L1 15" stroke="black"/>
                </svg>
              </button>
            </div>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {filtr}
          </Offcanvas.Body>
        </Offcanvas>
      </>
    )
  }
}

Katalog.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  changeFavorite: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  user_profile_type: PropTypes.string,
  catalogmenu: PropTypes.array,
  favorite_page: PropTypes.bool,
  catalog: PropTypes.array
}